"use client";

import { useStore } from "@/lib/store";
import type { Issue } from "@/lib/types";

/**
 * "🙏 you" pill rendered on every issue card / row when the current user is
 * the requester AND the agent moved the issue to `in_review`. PAUT-63.
 *
 * The whole point: scanning the board, you see at a glance which tickets are
 * waiting for YOU specifically, without opening each card.
 *
 * Same condition as the sidebar's "Awaiting me" filter — kept in lockstep so
 * the badge count and the filter always agree.
 */
export function AwaitingMeBadge({ issue }: { issue: Issue }) {
  const currentUserId = useStore((s) => s.currentUserId);
  if (issue.status !== "in_review") return null;
  if (issue.requesterId !== currentUserId) return null;
  return (
    <span
      className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[10px] font-medium bg-[var(--accent-bg)] text-[var(--accent)] border border-[var(--accent)]/40"
      title="You're the requester — the agent moved this to in_review for your sign-off"
    >
      🙏 you
    </span>
  );
}
